<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="card">
        <div class="card-body">
          <div id="titulo" class="panel panel-default">
            <!-- Default panel contents -->
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <h4>Lista de Veiculos</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <router-link id="btnNovoVeiculo" class="btn btn-success" to="/veiculos/novo">
                    <span class="glyphicon glyphicon-plus"></span> Novo
                  </router-link>
                  <button id="relatorios" type="button" class="btn btn-primary">
                    <span class="glyphicon glyphicon-plus"></span> Relatórios
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="filtros" class="panel panel-default">
            <!-- Default panel contents -->
            <div class="panel-body">
              <div class="row">
                <div class="col-sm-1 col-md-1">
                  <div class="form-group">
                    <label class="label-filtros">Exibir:</label>
                    <select class="form-control custom" v-model="filtros.status">
                      <option value="A" label="Ativos">Ativos</option>
                      <option value="D" label="Desativados">Desativados</option>
                      <option value="T" label="Todos">Todos</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-9 col-md-9">
                  <div class="form-group has-feedback">
                    <label class="label-filtros">Buscar:</label><br>
                    <input class="form-control hasclear" type="text" v-model="filtros.buscas" v-on:keyup.enter="buscar(1)"/>
                    <span id="limparbusca" class="glyphicon glyphicon-remove-circle"></span>
                  </div>
                </div>
                <div class="col-sm-1 col-md-1">
                  <div class="form-group">
                    <label class="label-filtros">Exibir:</label>
                    <select class="form-control custom" v-model="filtros.quantidade">
                      <option value="15" label="15">15</option>
                      <option value="30" label="30">30</option>
                      <option value="50" label="50">50</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-1 col-md-1">
                  <div class="form-group">
                    <label class="label-filtros">&nbsp;</label><br>
                    <input class="btn btn-block btn-success" type="button" v-on:click="buscar(1)" value="Buscar">
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12">
              <div id="dados-paginacao">
                <input id="idsSelecionados" type="hidden"/>
                <table id="tabelaVeiculos"
                class="table table-responsive-sm table-hover table-outline mb-0"
                width="100%">
                <thead class="thead-light">
                  <tr>
                    <th>Ativo</th>
                    <th>Código</th>
                    <th>Cliente</th>
                    <th>Veículo</th>
                    <th>Marca</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="veiculo in dadosTabela" :class="{ 'selecionado': selecionado(veiculo) }" @click="selecionarItem(veiculo)" v-on:dblclick="editar(veiculo.id)">
                    <td width="40"><input type="hidden" :id="veiculo.id" class="id"/>
                      <template v-if="veiculo.ativo">
                        <img src="/static/images/true.png" />
                      </template>
                      <template v-else>
                        <img src="/static/images/false.png" />
                      </template>
                    </td>
                    <td width="50">{{veiculo.id}}</td>
                    <td width="450">
                      <strong>{{veiculo.clienteNome}}</strong>
                    </td>
                    <td width="450">
                      <strong>{{veiculo.descricao}}</strong>
                      <br>
                      <small class="text-muted">{{veiculo.placa}}</small>
                    </td>
                    <td width="450">
                      <strong>{{veiculo.modelo}}</strong>
                      <br>
                      <small class="text-muted">{{veiculo.marca}}</small>
                    </td>
                    <td width="80">
                      <router-link v-tooltip="'Editar'" :to="{name: 'VeiculosEditar', params: { id: veiculo.id }}" class="">
                        <img src="/static/images/editar.png" />
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <vue-pages :url="url" :total="totalPaginas" :counts="counts" :current="filtros.pagina" :fn="paginacao"></vue-pages>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

</template>
<script>
import vuePages from 'vue-pages'
import axios from 'axios'
export default {
  data () {
    return {
      filtros: {
        buscas: this.$store.state.filtrosVeiculo.buscas,
        pagina: this.$store.state.filtrosVeiculo.pagina,
        quantidade: this.$store.state.filtrosVeiculo.quantidade,
        status: this.$store.state.filtrosVeiculo.status,
        selecionada: this.$store.state.filtrosVeiculo.selecionada
      },
      dadosTabela: [],
      url: '#',
      totalPaginas: 1,
      counts: 10
    }
  },
  created: function () {
    this.buscar(this.$store.state.filtrosVeiculo.pagina)
  },
  components: {
    vuePages
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    selecionarItem: function (item) {
      console.log(item.id)
      this.filtros.selecionada = item.id
    },
    selecionado: function (item) {
      return this.filtros.selecionada === item.id
    },
    paginacao (d, e) {
      this.filtros.pagina = d
      this.buscar(this.filtros.pagina)
    },
    buscar: function (pagina) {
      this.filtros.pagina = pagina
      var self = this
      this.$store.commit('SET_FILTROS_VEICULO', self.filtros)
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/veiculos?buscas=' + this.filtros.buscas + '&pagina=' + this.filtros.pagina + '&quantidade=' + this.filtros.quantidade + '&status=' + this.filtros.status
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosTabela = dadosCadastro.dados
        self.totalPaginas = dadosCadastro.totalPaginas
      })
    },
    editar: function (id) {
      this.$router.replace('/veiculos/editar/' + id)
    },
    deletar: function (id) {
      let self = this
      let dadosCadastro
      let message = 'Deseja realmente deletar esse Veículo?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        setTimeout(() => {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.loading = true
          var url = '/api/veiculos/deletar/' + id
          axios.get(url, config)
          .then(function (response) {
            console.log(response)
            if (response.data === 'OK') {
              self.$toastr('success', 'Veículo deletado com sucesso.', 'Atenção')
              url = '/api/veiculos?buscas=' + self.filtros.buscas + '&pagina=' + self.filtros.pagina + '&quantidade=' + self.filtros.quantidade + '&status=' + self.filtros.status
              axios.get(url, config)
              .then(function (response) {
                console.log(response.data)
                dadosCadastro = response.data
                self.dadosTabela = dadosCadastro.dados
                self.totalPaginas = dadosCadastro.totalPaginas
                dialog.close()
              })
            } else {
              self.$toastr('error', 'Esse Veículo está em USO e não pode ser deletado.', 'Atenção')
              dialog.close()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        }, 2500)
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/veiculos/VeiculosLista.vue